import AnchorLink from './anchor-link';
export default AnchorLink;
export type { AnchorLinkProps } from './anchor-link';
